import { Button } from "@chakra-ui/react";

const CustomButton = ({ border, bg, color, text }: any) => {
  return (
    <Button
      w={"100%"}
      variant={"unstyled"}
      h={"65px"}
      borderRadius={"20px"}
      border={border || "none"}
      p={"5px"}
      bg={bg || "#E17F09"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      fontSize={{ base: "16px", md: "24px" }}
      lineHeight={"27.31px"}
      color={color || "#FFFAFF"}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
